export { default as GFC_webp } from './GFC.webp';
export { default as Nineteen_webp } from './1984.webp';
export { default as Nuwa_webp } from './Nuwa.webp';
export { default as RAED_webp } from './RAED.webp';
export { default as Algebra_webp } from './Algebra.webp';
